import { render, staticRenderFns } from "./Ordercreat.vue?vue&type=template&id=c2844454"
import script from "./Ordercreat.vue?vue&type=script&lang=js"
export * from "./Ordercreat.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports